const stackedTextImageBlock = {
  displayField: 'eyebrow',
  name: 'Stacked Text and Image Block',
  description: '',
  fields: [
    {
      id: 'img',
      name: 'Left Image',
      type: 'Link',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'imageCircle',
      name: 'Left Image Circle',
      type: 'Boolean',
      localized: false,
      required: false,
      validations: [],
      defaultValue: { 'en-US': false },
      disabled: false,
      omitted: false
    },
    {
      id: 'eyebrow',
      name: 'Left Eyebrow',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [ { size: { min: null, max: 256 } } ],
      disabled: false,
      omitted: false
    },
    {
      id: 'header',
      name: 'Left Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [ { size: { min: null, max: 256 } } ],
      disabled: false,
      omitted: false
    },
    {
      id: 'bodyText',
      name: 'Left Body Text',
      type: 'Text',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'ctaText',
      name: 'Left Button Text',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'ctaUrl',
      name: 'Left Button Url',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'buttonExternalOption',
      name: 'Left Button External Option',
      type: 'Boolean',
      localized: false,
      required: false,
      validations: [],
      defaultValue: { 'en-US': false },
      disabled: false,
      omitted: false
    },
    {
      id: 'img2',
      name: 'Right Image',
      type: 'Link',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'imageCircle2',
      name: 'Right Image Circle',
      type: 'Boolean',
      localized: false,
      required: false,
      validations: [],
      defaultValue: { 'en-US': false },
      disabled: false,
      omitted: false
    },
    {
      id: 'eyebrow2',
      name: 'Right Eyebrow',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [ { size: { min: null, max: 256 } } ],
      disabled: false,
      omitted: false
    },
    {
      id: 'header2',
      name: 'Right Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [ { size: { min: null, max: 256 } } ],
      disabled: false,
      omitted: false
    },
    {
      id: 'bodyText2',
      name: 'Right Body Text',
      type: 'Text',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'ctaText2',
      name: 'Right Button Text',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'ctaUrl2',
      name: 'Right Button Url',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'buttonExternalOption2',
      name: 'Right Button External Option',
      type: 'Boolean',
      localized: false,
      required: false,
      validations: [],
      defaultValue: { 'en-US': false },
      disabled: false,
      omitted: false
    },
    {
      id: 'reverse',
      name: 'Reverse',
      type: 'Boolean',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'stackedTextImageBlock',
    version: 62,
    updatedAt: '2023-08-03T14:36:55.743Z'
  }
};
export default stackedTextImageBlock;